import { TokenService } from './../services/token.service';
import { Injectable } from '@angular/core';
import { CommonConstants, RouteConstants } from 'src/app/shared/constant';
import { AuthService, ToastService } from '../services';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly tokenService: TokenService,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = this.tokenService.getToken();
    const role = token?.roles;
    const rolesToCheck = route.data['roles'] as Array<string>;
    const access = rolesToCheck.some((s) => s === role);
    const routeToCheck = route.data['route'] as number;

    if (
      routeToCheck !== RouteConstants.Route.Restaurant &&
      routeToCheck !== RouteConstants.Route.AddRestaurant &&
      routeToCheck !== RouteConstants.Route.ApplicationUser &&
      routeToCheck !== RouteConstants.Route.BlockedUser &&
      routeToCheck !== RouteConstants.Route.Assignment &&
      routeToCheck !== RouteConstants.Route.MasterThirdParty &&
      routeToCheck !== RouteConstants.Route.MasterMenuImageTag &&
      routeToCheck !== RouteConstants.Route.PaidDiagnostic &&
      routeToCheck !== RouteConstants.Route.UnPaidDiagnostic &&
      routeToCheck !== RouteConstants.Route.PendingDiagnostic &&
      routeToCheck !== RouteConstants.Route.OutletDiagnostic &&
      routeToCheck !== RouteConstants.Route.Search &&
      token.restaurantId === 0
    ) {
      this.toastService.showError('Invalid Restaurant Selected');
      return false;
    }

    if (
      routeToCheck !== RouteConstants.Route.Restaurant &&
      routeToCheck !== RouteConstants.Route.AddRestaurant &&
      routeToCheck !== RouteConstants.Route.ApplicationUser &&
      routeToCheck !== RouteConstants.Route.BlockedUser &&
      routeToCheck !== RouteConstants.Route.Assignment &&
      routeToCheck !== RouteConstants.Route.MasterThirdParty &&
      routeToCheck !== RouteConstants.Route.MasterMenuImageTag &&
      routeToCheck !== RouteConstants.Route.PaidDiagnostic &&
      routeToCheck !== RouteConstants.Route.UnPaidDiagnostic &&
      routeToCheck !== RouteConstants.Route.PendingDiagnostic &&
      routeToCheck !== RouteConstants.Route.OutletDiagnostic &&
      routeToCheck !== RouteConstants.Route.Search &&
      routeToCheck !== RouteConstants.Route.Outlet &&
      routeToCheck !== RouteConstants.Route.AddOutlet &&
      routeToCheck !== RouteConstants.Route.Customer &&
      routeToCheck !== RouteConstants.Route.GuestCustomer &&
      routeToCheck !== RouteConstants.Route.BlockedCustomer &&
      routeToCheck !== RouteConstants.Route.Notification &&
      routeToCheck !== RouteConstants.Route.Banner &&
      routeToCheck !== RouteConstants.Route.Gallery &&
      token.outletId === 0
    ) {
      this.toastService.showError('Invalid Outlet Selected');
      return false;
    }

    if (access) {
      return true;
    }

    const isFeatureAccess = this.authService.getModuleAccess(
      RouteConstants.ManagerAccess.AccessFeature,
    );
    if (
      role === CommonConstants.Role[CommonConstants.Role.Manager] &&
      routeToCheck === RouteConstants.Route.Feature &&
      isFeatureAccess
    ) {
      return true;
    }

    const isPaymentAccess = this.authService.getModuleAccess(
      RouteConstants.ManagerAccess.AccessPayment,
    );
    if (
      role === CommonConstants.Role[CommonConstants.Role.Manager] &&
      routeToCheck === RouteConstants.Route.PaymentMode &&
      isPaymentAccess
    ) {
      return true;
    }

    const isPasswordAccess = this.authService.getModuleAccess(
      RouteConstants.ManagerAccess.AccessPassword,
    );
    if (
      role === CommonConstants.Role[CommonConstants.Role.Manager] &&
      routeToCheck === RouteConstants.Route.User &&
      isPasswordAccess
    ) {
      return true;
    }

    //this.router.navigate(['/home/dashboard']);
    this.toastService.showError('You dont have permission to access this');
    return false;
  }
}
